// @flow

import gql from 'graphql-tag';

const appIntegrationBrowserQuery = gql`
  query appIntegrationBrowserQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      slug
      pairedApps(limit: 250) {
        integrationsCount
        app {
          id
          image
          categories {
            id
            name
          }
          name
          slug
        }
      }
    }
  }
`;

export default appIntegrationBrowserQuery;
